<template>
    <div>
        <swb-query-sort-area ref="query_model" :config="queryConfig" :queryKey="queryKey" :queryHandler="queryHandler"></swb-query-sort-area>
    </div>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import SwbQuerySortArea from '../query/QuerySortArea';

    Vue.regist(SwbQuerySortArea);

    Vue.regist(SwbQuerySortArea);

    let searchConfigData = {
        "queryFields": [
            {
                "type": "Text",
                "label": "订单号",
                "code": "no",
                "valueType": "String",
                "basic": true
            },
            {
                "type": "Text",
                "label": "合同单号",
                "code": "contractNo",
                "basic": true,
                "valueType": "String"
            },
            {
                "type": "Text",
                "label": "交易单号",
                "code": "tradeNo",
                "basic": true,
                "valueType": "String"
            },
            {
                "type": "Date2",
                "valueType": "String",
                "label": "创建时间",
                "code": "createTime",
                "basic": true
            },
            {
                "type": "Select",
                "label": "支付状态",
                "code": "state",
                "basic": false,
                "dataList": [
                    {
                        "value": null,
                        "label": "- 全部 -"
                    },
                    {
                        "value": "Undelivered",
                        "label": "待交付"
                    },
                    {
                        "value": "InDelivered",
                        "label": "交付中"
                    },
                    {
                        "value": "Completed",
                        "label": "交付完成"
                    }
                ]
            },
            {
                "type": "Select",
                "label": "交易状态",
                "code": "workAssignStateX",
                "dataList": [
                    {
                        "value": null,
                        "label": "- 全部 -"
                    },
                    {
                        "value": "Not",
                        "label": "未派工"
                    },
                    {
                        "value": "Partial",
                        "label": "已部分派工"
                    },
                    {
                        "value": "All",
                        "label": "已全部派工"
                    }
                ]
            }
        ],
        "sortFields": [
            {
                "label": "创建时间",
                "code": "createTime",
                "enabled": true,
                "order": "desc"
            }
        ]
    };

    export default {
        name: 'swb-servc-order-search',
        desc: '服务订单搜索',
        props: ['no', 'isContract', 'contractId'],
        data: function () {
            return {
                queryConfig: null,
                queryKey: null,
                queryConfigMap: {}
            }
        },
        watch: {
            '$route': 'fetchData'
        },
        created: function () {
            this.fetchData();
        },
        methods: {
            fetchData: function () {
                //查询排序配置信息
                let queryConfig = Utils.merge({}, searchConfigData);
                //查询回调函数调用上下文对象
                //queryConfig.queryContext = this;
                this.queryConfigMap = queryConfig.queryFields.toMap("code");
                if(!Utils.isNoB(this.no)) {
                    let queryConfigOb = this.queryConfigMap["no"];
                    queryConfigOb.value = this.no;
                }
                //
                let item = this.queryConfigMap["contractNo"];
                let item2 = this.queryConfigMap["tradeNo"];
                let isContract = this.isContract || false;
                if(isContract) {
                    if(!Utils.isNoB(this.contractId)) {
                        item.hidden = true;
                    }
                    item2.basic = false;
                } else {
                    item.hidden = true;
                }
                this.queryConfig = queryConfig;
            },
            queryHandler(queryModel) {
                console.log('----------  查询、排序参数 ---------');

                console.log(queryModel);

                this.$emit("showServcOrderSearch", queryModel)
                //调用查询...
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/servcOrder/ServcOrderSearchLet.vue